import { combineReducers } from "redux";
import { applicationReducer, ApplicationState } from "./applicationsReducer";
import { postulateReducer, PostulateState } from "./postulateReducer";
import { provinceReducer, ProvinceState } from "./provinceReducer";
import { candidateReducer, CandidateState } from "./candidateReducer";
import { problemReducer, ProblemState } from "./problemReducer";
import { codeReducer, CodeState } from "./codeReducer";
import { ResourceState, resourceReducer } from "./resource.reducer";

export interface IRootState {
  applicationReducer: ApplicationState; // debemos poner el homestate
  postulateReducer: PostulateState; // debemos poner el homestate
  provinceReducer: ProvinceState;
  candidateReducer: CandidateState;
  problemReducer: ProblemState;
  codeReducer: CodeState;
  resourceReducer: ResourceState;
}

const rootReducer = combineReducers<IRootState>({
  applicationReducer,
  postulateReducer,
  provinceReducer,
  candidateReducer,
  problemReducer,
  codeReducer,
  resourceReducer,
});

export default rootReducer;
